import _ from "lodash"

export default function convertServicesSlug(service_cats, service, slug) {
  let active_slug = slug

  // Get parent service category to set slug
  let parent_service = service_cats.edges.find(
    obj => obj.node.frontmatter.cat_id === service.frontmatter.category
  )

  // If parent_service exists, update slug
  if (parent_service) {
    active_slug = `/services/${_.kebabCase(
      parent_service.node.frontmatter.name
    )}/${_.kebabCase(service.frontmatter.name)}`
  }

  return active_slug
}
